"use client";

import { staggerChildren } from "../config/animation";

import { InView } from "./motion-primitives/in-view";
import InfoCard from "./info-card";

type InfoCardItem = {
  key: string;
  title: string;
  description: string;
  number: number;
};

type InfoGridClientProps = {
  cards: InfoCardItem[];
};

const VIEWPORT_MARGIN = "0px 0px -250px 0px";
const STAGGER_DELAY = 0.09;

export default function InfoGridClient({ cards }: InfoGridClientProps) {
  return (
    <InView
      variants={staggerChildren(STAGGER_DELAY)}
      viewOptions={{ once: true, margin: VIEWPORT_MARGIN }}
    >
      <div className="grid gap-8 pt-8 sm:grid-cols-3 sm:grid-rows-2">
        {cards.map((card) => (
          <InfoCard
            key={card.key}
            description={card.description}
            number={card.number}
            title={card.title}
          />
        ))}
      </div>
    </InView>
  );
}
